"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
exports.InteractableIdAttributeName = 'x-react-zoomable-ui-interactable-id';
/**
 * Helper function that returns the nearest ancestor element to the passed
 * element that is an interactable (either `Pressable` or `NoPanArea`), or
 * the element itself if it is interactable.
 */
function getInteractableIdMostApplicableToElement(element, outerContainerClassName) {
    for (const e of utils_1.walkElementHierarchyUp(element)) {
        if (outerContainerClassName && e.classList.contains(outerContainerClassName)) {
            return undefined;
        }
        const a = e.getAttribute(exports.InteractableIdAttributeName);
        if (a) {
            return a;
        }
    }
    return undefined;
}
exports.getInteractableIdMostApplicableToElement = getInteractableIdMostApplicableToElement;
//# sourceMappingURL=Interactable.js.map